import { TSanitizeChannelSplitterOptionsFunction } from '../types';

export const sanitizeChannelSplitterOptions: TSanitizeChannelSplitterOptionsFunction = (options) => {
    return { ...options, channelCount: options.numberOfOutputs };
};
